import React from 'react';
import { motion } from 'framer-motion';
import { Star, Sparkles } from 'lucide-react';
const testimonials = [{
  name: 'Valentina',
  text: 'El mejor lugar para cuidar mis uñas y cejas. Siempre salgo feliz con los resultados. La atención es increíble y el ambiente súper profesional.',
  rating: 5
}, {
  name: 'Sofía',
  text: 'Me hice el alisado progresivo y quedé encantada. Mi cabello nunca se vio tan saludable y brillante. Totalmente recomendado.',
  rating: 5
}, {
  name: 'Camila',
  text: 'Las extensiones de pestañas son perfectas. Duran mucho y se ven naturales. El laminado de cejas también es espectacular. No cambio este lugar por nada.',
  rating: 5
}];
export function Testimonials() {
  return <section id="testimonials" className="w-full py-20 px-4 bg-cream" data-id="element-178">
      <div className="max-w-7xl mx-auto" data-id="element-179">
        <div className="text-center mb-16" data-id="element-180">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4 flex items-center justify-center gap-3" data-id="element-181">
            Lo que dicen nuestras clientas
            <Sparkles className="w-8 h-8 text-gold" data-id="element-182" />
          </h2>
          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-183">
            <div className="w-16 h-0.5 bg-gold" data-id="element-184" />
            <div className="w-2 h-2 bg-gold rotate-45" data-id="element-185" />
            <div className="w-16 h-0.5 bg-gold" data-id="element-186" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-187">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-lg shadow-pink/20 hover:shadow-xl hover:shadow-pink/30 transition-shadow" data-id="element-188">
              <div className="flex gap-1 mb-4" data-id="element-189">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-190" />)}
              </div>

              <p className="text-charcoal/80 mb-6 italic leading-relaxed" data-id="element-191">
                "{testimonial.text}"
              </p>

              <p className="text-gold font-semibold text-lg" data-id="element-192">
                — {testimonial.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}